import React from 'react';

import toastService from './toast';
import apiService from './api';

class Checkout extends React.Component{

    state = { 
        name: '', 
        nameErr: '',  
        phone: '', 
        phoneErr: '',  
        email: '', 
        emailErr: ''
    }

    async loadScript(src){
        return new Promise((resolve) => {
            const script = document.createElement("script");
            script.src = src;
            script.onload = () => {
                resolve(true);
            };
            script.onerror = () => {
                resolve(false);
            };
            document.body.appendChild(script);
        })
    }

    displayRazorpay = async ()=>{
        const rp = await this.loadScript(
            "https://checkout.razorpay.com/v1/checkout.js"
        );

        if (!rp) {
            // toast err
            toastService.error();
            return;
        }

        // creating a new order
        const result = await apiService.createOrder({
            workshopId: '6381ff49a25c613e3a6a6308',
            name: this.state.name,
            email: this.state.email,
            number: this.state.phone,
            city: this.state.city,
            qualification: this.state.qualification,
            date: new Date()
        })

        if (!result) {
            // toast err
            toastService.error();
            return;
        }

        // Getting the order details back
        const { amount, id: order_id, currency } = result.data.order;

        const options = {
            key: "rzp_live_3zTUV5jP5Z41tX", // Enter the Key ID generated from the Dashboard
            amount: amount.toString(),
            currency: currency,
            name: this.state['name'],
            description: "Certificate in Fundamentals of Azure for Data Science",
            order_id: order_id,
            handler: async (response)=>{
                const data = {
                    orderCreationId: order_id,
                    razorpayPaymentId: response.razorpay_payment_id,
                    razorpayOrderId: response.razorpay_order_id,
                    razorpaySignature: response.razorpay_signature,
                };

                let verify = await apiService.paymentVerify(data);
                if(verify.data['status'] === 'success'){
                    // toast success
                    toastService.success('Payment successfull!');
                    window.location.href = 'https://businesstoys.in/cbc/thank-you/';
                }else{
                    // toast err
                    toastService.error('Payment validation failed');
                }
            },
            prefill: {
                name: this.state['name'],
                email: this.state['email'],
                contact: this.state['phone'],
            },
            notes: {
                address: "",
            },
            theme: {
                color: "#1C47FC",
            },
        };

        const paymentObject = new window.Razorpay(options);
        paymentObject.open();
    }

    formSubmit = async (e)=>{
        e.preventDefault();
        await this.setState({ phoneErr: "", nameErr: "", emailErr: "" });
        if(this.state.name.length < 3){
            await this.setState({ nameErr:'Enter valid name' })
        }
        if(this.state.phone.length !== 10){
            await this.setState({ phoneErr: 'Enter valid 10 digit number' });
        }
        if(!(/^\d+$/.test(this.state.phone))){
            await this.setState({ phoneErr: 'Phone must contain only numbers' })
        }
        if(this.state.phoneErr || this.state.emailErr || this.state.nameErr){
            toastService.error('Enter valid values');
            return;
        }
        console.log('submit');
        this.displayRazorpay();
    } 

    render(){
        return(
            <div className='content-body' >
                <section className='checkout' >
                <h1>
                    Just one last step!
                </h1>
                <div className='checkout__container' >
                    <div className='checkout__container--txt' >
                        <h2>Book Now & lock your BONUSES...</h2>
                        <p>We are locking following benefits for you while you finish your purchase</p>
                        <div className='checkout__container--txt__points' >
                            <div className='checkout__container--txt__points-p' >
                                <img loading="auto"src='https://businesstoys.in/assets/cbc-2/images/tick.png' alt='yellow' />
                                <h4>Top Industry Trainer</h4>
                            </div>
                            <div className='checkout__container--txt__points-p' >
                                <img loading="auto"src='https://businesstoys.in/assets/cbc-2/images/tick.png' alt='yellow' />
                                <h4>Learning Material worth of ₹1,500/- </h4>
                            </div>
                            <div className='checkout__container--txt__points-p' >
                                <img loading="auto"src='https://businesstoys.in/assets/cbc-2/images/tick.png' alt='yellow' />
                                <h4>Exciting Giveaway and Prizes</h4>
                            </div>
                            <div className='checkout__container--txt__points-p' >
                                <img loading="auto"src='https://businesstoys.in/assets/cbc-2/images/tick.png' alt='yellow' />
                                <h4>Invaluable learnings from the webinar while saving ₹ 7,001</h4>
                            </div>
                    
                        </div>
                    </div>
                    <div className='checkout__container--form' >
                        <h2>Price for you: <span>₹7,999</span></h2>
                        <h3>Normal Price: <span>₹15,000</span></h3>
                        <div className='checkout__container--form--today' >
                            Get Your Bonuses, TODAY!
                        </div>
                        <form onSubmit={this.formSubmit} >
                            <h4>Fill Your Details</h4>
                            <div className='checkout__container--form--ip' >
                                <input type="text" placeholder='Full Name *' 
                                value={this.state.name}
                                required
                                onChange={e=>this.setState({ name: e.target.value })}
                                />
                                <span>{this.state.nameErr}</span>
                            </div>
                            <div className='checkout__container--form--ip' >
                                <input type="tel" placeholder='Phone *' 
                                value={this.state.phone}
                                required
                                onChange={e=>this.setState({ phone: e.target.value })}
                                />
                                <span>{this.state.phoneErr}</span>
                            </div>
                            <div className='checkout__container--form--ip' >
                                <input type="email" placeholder='Email *' 
                                value={this.state.email}
                                required
                                onChange={e=>this.setState({ email: e.target.value })}
                                />
                                <span>{this.state.emailErr}</span>
                            </div>
                            <div className='checkout__container--form--icons' >
                                <img loading="auto" src='https://businesstoys.in/assets/cbc-2/images/checkout/payment-3.png' alt='1' />
                                <img loading="auto" src='https://businesstoys.in/assets/cbc-2/images/checkout/payment-1.png' alt='1' />
                                <img loading="auto" src='https://businesstoys.in/assets/cbc-2/images/checkout/payment-2.png' alt='1' />
                                <img loading="auto" src='https://businesstoys.in/assets/cbc-2/images/checkout/payment-4.png' alt='1' />
                            </div>
                            <button>Book my seat</button>
                        </form>
                    </div>
                </div>
                </section>
            </div>
        )
    }
};

export default Checkout;